var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2546 28.9497L19.0496 35.7447C21.8396 38.5347 26.3696 38.5347 29.1746 35.7447L35.7596 29.1597C38.5496 26.3697 38.5496 21.8397 35.7596 19.0347L28.9496 12.2547C27.5246 10.8297 25.5596 10.0647 23.5496 10.1697L16.0496 10.5297C13.0496 10.6647 10.6646 13.0497 10.5146 16.0347L10.1546 23.5347C10.0646 25.5597 10.8296 27.5247 12.2546 28.9497Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2497 24.5697C22.6356 24.5697 24.5697 22.6356 24.5697 20.2497C24.5697 17.8638 22.6356 15.9297 20.2497 15.9297C17.8638 15.9297 15.9297 17.8638 15.9297 20.2497C15.9297 22.6356 17.8638 24.5697 20.2497 24.5697Z",
    fill: "#111827"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5002 32.6252C25.2152 32.6252 24.9302 32.5202 24.7052 32.2952C24.2702 31.8602 24.2702 31.1402 24.7052 30.7052L30.7052 24.7052C31.1402 24.2702 31.8602 24.2702 32.2952 24.7052C32.7302 25.1402 32.7302 25.8602 32.2952 26.2952L26.2952 32.2952C26.0702 32.5202 25.7852 32.6252 25.5002 32.6252Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag2);
export default __webpack_public_path__ + "static/media/tag2.c8eb64162d26f3bc8d6310b10cb22bdc.svg";
export { ForwardRef as ReactComponent };